<template>
    <div>
        <SaveDraft @SaveDraft="SaveDraft()" :Editor="Editor"></SaveDraft>
        <Publish @Publish="Publish()" :Editor="Editor"></Publish>
        <RevisionHistory @RevisionHistory="RevisionHistory()" :Editor="Editor"></RevisionHistory>
    </div>
</template>

<script>

import SaveDraft from '@/views/components/atoms/tiptap/Predefined/Buttons/Actions/SaveDraft.vue';
import Publish from '@/views/components/atoms/tiptap/Predefined/Buttons/Actions/Publish.vue';
import RevisionHistory from '@/views/components/atoms/tiptap/Predefined/Buttons/Actions/RevisionHistory.vue';

export default ({
    methods: {
        Publish() {
            this.$emit('Publish');
        },
        SaveDraft() {
            this.$emit('SaveDraft');
        },
        RevisionHistory(){
            this.$emit('RevisionHistory');
        }
    },
    components: {
        SaveDraft,
        Publish,
        RevisionHistory
    },
    props: ["Editor"]
});
</script>